import { msg } from '@lingui/macro';

export const DirectSuppliersRoutes = {
  path: 'direct-suppliers',
  async lazy() {
    const { Parent } = await import('pages/direct-suppliers');
    return { Component: Parent };
  },
  handle: {
    name: 'Direct Suppliers',
    category: 'Supplier management',
    title: msg`Direct Suppliers`,
  },
  children: [
    {
      path: '',
      async lazy() {
        const { Index } = await import('pages/direct-suppliers');
        return { Component: Index };
      },
      children: [
        {
          path: ':supplierId',
          async lazy() {
            const { Details } = await import('pages/direct-suppliers');
            return { Component: Details };
          },
          handle: { name: 'Direct Supplier Details', category: 'Supplier management' },
        },
      ],
    },
    {
      path: ':supplierId/full-details',
      async lazy() {
        const { DetailsFullView } = await import('pages/direct-suppliers');
        return { Component: DetailsFullView };
      },
      handle: { name: 'Direct Supplier Full Details', category: 'Supplier management' },
      children: [
        {
          index: true,
          async lazy() {
            const { Users } = await import('pages/direct-suppliers');
            return { Component: Users };
          },
        },
        {
          path: 'users',
          async lazy() {
            const { Users } = await import('pages/direct-suppliers');
            return { Component: Users };
          },
          handle: { name: 'Direct supplier users', category: 'Supplier management' },
        },
        {
          path: 'certificates',
          async lazy() {
            const { Certificates } = await import('pages/direct-suppliers');
            return { Component: Certificates };
          },
          handle: { name: 'Direct supplier certificates', category: 'Supplier management' },
        },
        {
          path: 'facilities',
          async lazy() {
            const { DirectSupplierAllFacilities } = await import('pages/direct-suppliers');
            return { Component: DirectSupplierAllFacilities };
          },
          handle: { name: 'Direct supplier facilities', category: 'Supplier management' },
          children: [
            {
              path: ':facilityId/details',
              async lazy() {
                const { DirectSupplierFacilityDetails } = await import('pages/direct-suppliers');
                return { Component: DirectSupplierFacilityDetails };
              },
              handle: {
                name: 'Direct Supplier Facility Details',
                category: 'Supplier management',
              },
            },
          ],
        },
        {
          path: 'subsuppliers',
          async lazy() {
            const { Subsuppliers } = await import('pages/direct-suppliers');
            return { Component: Subsuppliers };
          },
          handle: { name: 'Direct Supplier subsuppliers', category: 'Supplier management' },
        },
      ],
    },
    {
      path: ':directSupplierId/full-details/subsuppliers/:supplierId/:supplierOrgId',
      async lazy() {
        const { SubsuppliersDetails } = await import('pages/direct-suppliers');
        return { Component: SubsuppliersDetails };
      },
      handle: { name: 'Direct Supplier Subsuppliers Details', category: 'Supplier management' },
      children: [
        {
          index: true,
          async lazy() {
            const { DirectSupplierSubsupplierBasicInfo } = await import('pages/direct-suppliers');
            return { Component: DirectSupplierSubsupplierBasicInfo };
          },
          handle: {
            name: 'Direct Supplier Subsuppliers BasicInfo',
            category: 'Supplier management',
          },
        },
        {
          path: 'facilities',
          async lazy() {
            const { DirectSupplierSubsupplierFacilities } = await import('pages/direct-suppliers');
            return { Component: DirectSupplierSubsupplierFacilities };
          },
          handle: {
            name: 'Direct Supplier Subsupplier Facilities',
            category: 'Supplier management',
          },
          children: [
            {
              path: ':facilityId/details',
              async lazy() {
                const { DirectSupplierSubsupplierFacilityDetails } = await import(
                  'pages/direct-suppliers'
                );
                return { Component: DirectSupplierSubsupplierFacilityDetails };
              },
              handle: {
                name: 'Direct Supplier Subsupplier Facility Details',
                category: 'Supplier management',
              },
            },
          ],
        },
      ],
    },
  ],
};
